export const MEMBER_IDENTIFIER_RECOVERY_VALIDATION_RULES = {
  lastName: {
    isRequiredTrim: {
      value: true,
    },
  },
  firstName: {
    isRequiredTrim: {
      value: true,
    },
  },
  postalCode: {
    isRequiredTrim: {
      value: true,
    },
  },
  birthdate: {
    isRequiredTrim: {
      value: true,
    },
  },
  emailAddress: {
    isRequiredTrim: {
      value: true,
    },
    regex: {
      value: {
        pattern: /^$|^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
        customMessageKey: "validation.emailRegex",
      },
    },
  },
  phoneNumber: {
    isRequiredTrim: {
      value: true,
    },
  },
  condition1: {
    isRequiredTrim: {
      value: true,
      customMessageKey: "validation.customMessages.acceptCondition",
    },
  },
  condition2: {
    isRequiredTrim: {
      value: true,
      customMessageKey: "validation.customMessages.acceptCondition",
    },
  },
  condition3: {
    isRequiredTrim: {
      value: true,
      customMessageKey: "validation.customMessages.acceptCondition",
    },
  },
  condition4: {
    isRequiredTrim: {
      value: true,
      customMessageKey: "validation.customMessages.acceptCondition",
    },
  },
  gRecaptchaResponse: {
    isRequiredTrim: {
      customErrorLevel: "form",
      value: true,
      customMessageKey: "validation.customMessages.recaptcha",
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/member-identifier-recovery/memberIdentifierRecoveryValidationRules.js